import { render } from "./AdsBoxes.vue?vue&type=template&id=1efc887c&scoped=true"
import script from "./AdsBoxes.vue?vue&type=script&lang=js"
export * from "./AdsBoxes.vue?vue&type=script&lang=js"

import "./AdsBoxes.vue?vue&type=style&index=0&id=1efc887c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1efc887c"]])

export default __exports__